// Helpers for the read-only HyreDocs tab on a Bullhorn Company record.

const PENDING = ['sent', 'opened', 'in_progress'];
// pending_approval / approved are post-completion: the contact has finished.
const COMPLETED = ['completed', 'pending_approval', 'approved'];

export const isPending = (doc) => PENDING.includes(doc?.status);
export const isCompleted = (doc) => COMPLETED.includes(doc?.status);

export function summarize(documents) {
  const list = documents || [];
  return {
    total: list.length,
    completed: list.filter(isCompleted).length,
    pending: list.filter(isPending).length,
    opened: list.filter((d) => d.status === 'opened').length,
  };
}

// One stable key per person on a document: their Bullhorn id when we have it,
// else their email (a document's id can be missing; its email never is).
export const contactKey = (doc) => String(doc?.candidate_bullhorn_id || doc?.candidate_email || '').toLowerCase();

/** The distinct contacts that have documents, A-Z, for the "contact" filter. */
export function contactsIn(documents) {
  const byKey = new Map();
  for (const d of documents || []) {
    const key = contactKey(d);
    if (key && !byKey.has(key)) byKey.set(key, { key, name: d.candidate_name || d.candidate_email || 'Unknown contact' });
  }
  return [...byKey.values()].sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
}

/** status: 'all' | 'pending' | 'opened' | 'completed'; contact: 'all' or a contactKey. */
export function filterDocuments(documents, status = 'all', contact = 'all') {
  return (documents || []).filter((d) => {
    if (contact !== 'all' && contactKey(d) !== contact) return false;
    if (status === 'pending') return d.status === 'sent' || d.status === 'in_progress';
    if (status === 'opened') return d.status === 'opened';
    if (status === 'completed') return isCompleted(d);
    return true;
  });
}
